<template>
  <div>
    <section class="section section-shaped section-lg my-0">
      <div class="shape shape-style-1 bg-gradient-default">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </section>
    <section class="section pb-0 section-components">
      <div class="text-center" v-if="loading">
        <h1>Espere un momento por favor, no cierre esta ventana del navegador. </h1>
      </div>

      <div class="py-5 bg-secondary" v-if="messageAlert.status && !loading">
        <div class="container">
          <base-alert
            :type="messageAlert.type"
            dismissible
            v-if="messageAlert.status"
          >
            <span class="alert-inner--icon"
              ><i :class="messageAlert.icon"></i
            ></span>
            <span class="alert-inner--text">
              <strong>{{ messageAlert.message }}</strong>
            </span>
            <button
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </base-alert>
          
          <b-button 
            :variant="messageAlert.type == 'danger' ? 'danger':'success' " 
            @click="volverAtras"
          >
              {{messageAlert.type == 'danger' ? 'Volver al formulario':'Volver al inicio'}}
          </b-button>
        </div>
      </div>
      
      <div class="py-5 bg-secondary" v-if="!messageAlert.status && !loading">
        <div class="container">
          <!-- Inputs (alternative) -->
          <h3 class="h4 text-success font-weight-bold mb-4">
            Registro de nuevo ingreso
          </h3>
          <div class="mb-3">
            <small class="text-uppercase font-weight-bold"
              >Todos los datos son requeridos</small
            >
          </div>
          <b-form @submit.stop.prevent="guardarRegistro">
            <div class="row">
              <div class="col-lg-4 col-sm-6">
                <b-form-group
                  label="Nombre: "
                  label-cols-sm="3"
                  label-size="sm"
                >
                  <b-form-input
                    v-model="form.nombre"
                    placeholder="Ingrese su nombre"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-lg-4 col-sm-6">
                <b-form-group
                  label="Apellido: "
                  label-cols-sm="3"
                  label-size="sm"
                >
                  <b-form-input
                    placeholder="Ingrese su apellido"
                    v-model="form.apellido"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-lg-4 col-sm-6">
                <b-form-group
                  label="Cédula: "
                  label-cols-sm="3"
                  label-size="sm"
                >
                  <b-form-input
                    placeholder="Ingrese su numero de cédula"
                    v-model="form.cedula"
                    required
                    
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-lg-4 col-sm-6">
                <b-form-group
                  label="Correo electrónico: "
                  label-cols-sm="3"
                  label-size="sm"
                >
                  <b-form-input
                    placeholder="Ingrese su correo electrónico"
                    v-model="form.correo"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-lg-4 col-sm-6">
                <b-form-group
                  label="Dirección: "
                  label-cols-sm="3"
                  label-size="sm"
                >
                  <b-form-input
                    placeholder="Ingrese su dirección de residencia"
                    v-model="form.direccion"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-lg-4 col-sm-6">
                <b-form-group
                  label="Telefono: "
                  label-cols-sm="3"
                  label-size="sm"
                >
                  <b-form-input
                    placeholder="Ingrese su Teléfono"
                    v-model="form.telefono"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-lg-4 col-sm-6">
                <b-form-group
                  label="Catedra: "
                  label-cols-sm="3"
                  label-size="sm"
                >
                  <b-form-select
                    v-model="form.chair"
                    :options="options"

                    value-field="id"
                    text-field="nombre"
                  >
                  <template #first>
                    <b-form-select-option :value="null" disabled>-- Seleccione una catedra --</b-form-select-option>
                  </template>
                  </b-form-select>
                  
                </b-form-group>
              </div>
            </div>
            <div class="mb-3">
              <small class="text-uppercase text-success font-weight-bold mb-4"
                >Carga de documentos</small
              >
            </div>
            <div class="row">
              <div class="col-lg-4 col-sm-6">
                <b-form-group label="Foto" label-cols-sm="3" label-size="sm">
                  <b-form-file
                    id="foto"
                    size="sm"
                    @change="handleImage($event, 'foto')"
                    placeholder="No ha cargado archivo..."
                    class="input-select"
                    ref="foto"
                    required
                  ></b-form-file>
                  
                </b-form-group>
              </div>
              <div class="col-lg-4 col-sm-6">
                <b-form-group label="Cédula" label-cols-sm="3" label-size="sm">
                  <b-form-file
                    id="cedula_file"
                    size="sm"
                    @change="handleImage($event, 'cedula_file')"
                    placeholder="No ha cargado archivo..."
                    ref="cedula_file"
                    class="input-select"
                    required
                  ></b-form-file>
                </b-form-group>
              </div>
              <div class="col-lg-4 col-sm-6">
                <b-form-group
                  label="Estudios Cursados"
                  label-cols-sm="3"
                  label-size="sm"
                >
                  <b-form-file
                    id="estudios_cursados"
                    size="sm"
                    placeholder="No ha cargado archivo..."
                    class="input-select"
                    required
                    ref="estudios_cursados"
                    @change="handleImage($event, 'estudios_cursados')"
                  ></b-form-file>
                </b-form-group>
              </div>
              
              <div class="col-lg-6 col-sm-6">
                <b-form-group
                  label="Planilla de inscripción"
                  label-cols-sm="3"
                  label-size="sm"
                >
                  <b-form-file
                    id="planilla_ins"
                    size="sm"
                    placeholder="No ha cargado archivo..."
                    class="input-select"
                    required
                    ref="planilla_ins"
                    @change="handleImage($event, 'planilla_ins')"
                  ></b-form-file>
                </b-form-group>
              </div>
              <div class="col-lg-6 col-sm-6">
                <b-form-group
                  label="Autorización pastoral"
                  label-cols-sm="3"
                  label-size="sm"
                >
                  <b-form-file
                    id="autorizacion_pastoral"
                    size="sm"
                    placeholder="No ha cargado archivo..."
                    class="input-select"
                    required
                    ref="aut_pas"
                    @change="handleImage($event, 'autorizacion_pastoral')"
                  ></b-form-file>
                </b-form-group>
              </div>
              <!-- <div class="col-lg-12 col-sm-12">
                <b-checkbox v-model="declaracion">Aceptar declaración doctrinal</b-checkbox>
              </div> -->
              <!-- <button type="submit" :disabled="declaracionAceptada" class="btn btn-primary">
                Registrar
              </button> -->
              <button type="submit" class="btn btn-primary">
                Registrar
              </button>
            </div>
          </b-form>
          
        </div>
      </div>
    </section>
    <InscripcionesNuevas/>
   
  </div>
</template>
<script>
import ModalDeclaracionDoctrinal from './ModalDeclaracionDoctrinal.vue';
import InscripcionesNuevas from "../principal/NuevasInscripciones"  

export default {
  name:'Inscripciones',
  components: {
    ModalDeclaracionDoctrinal,
    InscripcionesNuevas
  },
  data() {
    
    return {
      form: {
        nombre: "",
        apellido: "",
        cedula: "",
        direccion: "",
        correo: "",
        telefono: "",
        chair: null,
        foto: null,
        autorizacion_pastoral: null,
        planilla_ins: null,
        cedula_file: null,
        estudios_cursados: null,
      },
      options: [],
      messageAlert: {
        status: false,
        type: null,
        message: {},
        icon: null,
      },
      loading:false,
      declaracion:false,
      declaracionAceptada:true
    };
  },
  mounted() {
    this.getCatedras();
  },
  methods: {
   async getCatedras() {
      /* var catedra = [{ nombre: "Catedra basica", id: 1 }];
      this.options = catedra; */
      const chairs = await this.$api({
          url: "getcatedrasabiertas",
          method: "GET"
        });
        this.options = chairs.data.data;

      /* chairs.then(res=>{

      }).catch(error=>{

      }); */
    },
    async guardarRegistro() {
      this.loading = true;
      
      var message =
        "Se inicio la inscripción, esperando aprobación, pronto nos contactaremos con usted.";
      try {
        await this.$api({
          url: "inscripcionpublica",
          method: "POST",
          data: this.form,
        });
        this.loading = false;
        
        this.messageConfig("success", "ni ni-like-2", message);
      } catch (e) {
        if (e.response == "422") {
          console.log("422" + " " + e);
        } else {
          if (e.response.status == "422") {
            var errors = e.response.data.errors;
            for (const property in errors) {
              var err =  errors[property];
            }
            this.messageConfig(
              "danger",
              "ni ni-fat-remove",
              err[0]
            );
          }
          if (e.response.status == "400") {
            var errors = e.response.data.message;
            this.messageConfig(
              "danger",
              "ni ni-fat-remove",
              errors
            );                        
          }

          if (e.response.status != "400" && e.response.status != "422") {
            var errors = 'Ocurrio un error, por favor contacte con algun administrador.';
            this.messageConfig(
              "danger",
              "ni ni-fat-remove",
              errors
            );                        
          }

        }
        this.loading = false;
      }
    },
    handleImage(e, type) {
      const image = e.target.files[0];
      this.validateFiles(image,type);
      this.createBase64Image(image, type).then((res) => {
        this.form[type] = res;
      });
    },
    createBase64Image(image, type) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    messageConfig(type, icon, message) {
      this.messageAlert.status = true;
      this.messageAlert.type = type;
      this.messageAlert.message = message;
      this.messageAlert.icon = icon;
      /* setTimeout(() => {
        this.messageAlert.status = false;
      }, 5000); */
    },
    volverAtras(){      
      if (this.messageAlert.type === 'danger') {        
        this.$router.go();
      }else{
        this.$router.push('/');
      }
    },
    validateFiles(image,type){
       if (type === 'foto' || type === 'cedula_file' || type === 'estudios_cursados') {
        if (image.type === 'image/png' || image.type === 'image/jpg' || image.type === 'image/jpeg' ) {
        }else{
          this.$refs[type].reset();
          alert('Debe ser tipo imagen en formato jpf, jpeg o png. Por favor vuelva a cargar la foto en el formato solicitado')
          return;
        }
      }
      if (type === 'planilla_ins') {
        if (image.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || image.type === 'application/msword' || image.type === 'image/png' || image.type === 'image/jpg' || image.type === 'image/jpeg' || image.type === 'application/pdf') {          
        }else{
          this.$refs[type].reset();
          alert('El formato debe ser tipo documento word, imagen o pdf')
          return;
        }
        
      }
      if (type==='autorizacion_pastoral') {
        if (image.type === 'image/png' || image.type === 'image/jpg' || image.type === 'image/jpeg' || image.type === 'application/pdf') {
        }else{
          this.$refs.aut_pas.value = '';
          alert('El formato debe ser de documento o de imagen.')
          return;
        }
      }

    }
  },
};
</script>
<style>
.input-select {
  content: "Buscar";
}
</style>
